import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import React, { type PropsWithChildren, useEffect } from 'react'
import { userDataQuery } from 'src/editor/api/queries/user-data-query'

export const growthbookClient = new GrowthBook({
  clientKey: process.env.GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NODE_ENV === 'development',
})

export function GrowthbookClientProvider({ children }: PropsWithChildren) {
  const { data: user } = userDataQuery.useQuery()

  useEffect(() => {
    if (process.env.GROWTHBOOK_CLIENT_KEY) {
      growthbookClient.init({ skipCache: true, streaming: true })
    }
  }, [])

  useEffect(() => {
    if (!user) {
      return
    }
    growthbookClient.setAttributes({
      id: user.id,
      roles: user.roles,
      userPlanId: user.userPlanId,
      country: user.country,
    })
  }, [user])

  return (
    <GrowthBookProvider growthbook={growthbookClient}>
      {children}
    </GrowthBookProvider>
  )
}
